
import React from "react";


const PrintAuditStatus = ({ data }) => {

    const groupByCategory = (statuses) => {
        return statuses.reduce((acc, item) => {
            if (!acc[item.group]) {
                acc[item.group] = [];
            }
            acc[item.group].push(item);
            return acc;
        }, {});
    };

    const formatDate = (isoDate) => {
        if (!isoDate) return "-";

        const date = new Date(isoDate);

        const options = {
            day: "2-digit",
            month: "short",
            year: "numeric",
        };

        const formattedDate = date.toLocaleDateString("en-GB", options);
        const formattedTime = date.toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        });

        return `${formattedDate} at ${formattedTime}`;
    };

    const statuses = data?.statuses || [];
    const grouped = groupByCategory(statuses);
    const completed = statuses.filter(s => s.checked).length;
    const pending = statuses.length - completed;
    const completionPercent = Math.round((completed / statuses.length) * 100);


    return (
        <div className=" min-h-screen p-6">


            <div className="bg-white mb-6 text-sm border" >

                {/* REPORT TITLE */}
                <div className=" bg-[#1f2f4a] text-white px-4 py-2 font-semibold uppercase text-sm tracking-wide">
                    <h1 className="text-xl font-bold uppercase tracking-wide">
                        Status Audit Report
                    </h1>

                    <p className="mt-1 text-xs font-semibold ">
                        {data?.reportNumber}
                    </p>
                </div>

                {/* BOOKING + PROGRESS */}
                <div className="px-4  grid grid-cols-2  border-t">

                    {/* LEFT — BOOKING INFO */}
                    <div className="border-r py-2">
                        <h2 className="text-sm font-semibold text-gray-800">
                            {data?.bookingContactPerson}
                        </h2>

                        <p className="text-xs text-gray-600 mt-3">
                            Entered on <span className="font-medium">{data?.bookingEnteredDate}</span>
                        </p>

                        <p className="text-xs text-gray-600 mt-1">
                            Entered by <span className="font-medium">{data?.bookingEnteredBy}</span>
                        </p>
                    </div>


                    {/* RIGHT — STATUS SUMMARY */}
                    <div className="flex items-center justify-end ">
                        <div className="grid grid-cols-2 gap-y-2 gap-x-3">
                            <div className="flex items-center gap-1">
                                <span className="text-[11px] uppercase text-gray-500">
                                    Total:
                                </span>
                                <span className="text-sm font-semibold text-gray-800">
                                    {statuses.length}
                                </span>
                            </div>
                            <div className="flex items-center gap-1">
                                <span className="text-[11px] uppercase text-gray-500">
                                    Completed:
                                </span>
                                <span className="text-sm font-semibold text-green-700">
                                    {completed}
                                </span>
                            </div>

                            <div className="flex items-center gap-1">
                                <span className="text-[11px] uppercase text-gray-500 ">
                                    Pending:
                                </span>
                                <span className="text-sm font-semibold text-orange-600">
                                    {pending}
                                </span>
                            </div>



                            <div className="flex items-center gap-1">
                                <span className="text-[11px] uppercase text-gray-500">
                                    Progress:
                                </span>
                                <span className="text-sm font-semibold text-blue-700">
                                    {completionPercent}%
                                </span>
                            </div>

                        </div>

                    </div>

                </div>

            </div>




            <div className="max-w-6xl mx-auto bg-white border ">


                {Object.entries(grouped).map(([group, items]) => (
                    <div key={group} className="border-b last:border-b-0">

                        {/* Section Header */}
                        <div className="bg-[#1f2f4a] text-white px-4 py-2 font-semibold uppercase text-sm tracking-wide">
                            {group.replace(/([A-Z])/g, " $1")}
                        </div>

                        {/* Section Content */}
                        <div className="grid grid-cols-1 border-t">

                            {items.map((status) => {
                                const dateKey = `${status.id}Dt`;
                                const dateValue = status[dateKey];

                                return (
                                    <div
                                        key={status.id}
                                        className="flex items-center  border-b last:border-b-0 px-4 py-2 text-[12px]"
                                    >
                                        {/* Label */}
                                        <div className="w-1/2 text-gray-700 font-medium ">
                                            {status?.label?.toLocaleUpperCase()}
                                        </div>

                                        {/* Colon */}
                                        <div className="px-2 text-gray-500">:</div>

                                        {/* Value */}
                                        <div
                                            className={`w-1/2 ${status.checked
                                                ? "text-green-600 font-semibold"
                                                : "text-gray-400"
                                                }`}
                                        >
                                            {status.checked
                                                ? `${status?.label?.toLocaleUpperCase()} ON ${formatDate(dateValue)?.toLocaleUpperCase()}`
                                                : "-"}
                                        </div>
                                    </div>
                                );
                            })}

                        </div>
                    </div>
                ))}

            </div>
        </div>

    );
};

export default PrintAuditStatus;
